<template>
  <div>
    <dashboard-header :text="$t('schedule.detailCaption')" :on-back="onGoBack" />

    <div class="d-flex align-content-center justify-content-center">
      <v-card elevation="0" :loading="loading" class="card-border-10 mx-16 w-75">
        <div class="pa-5">
          <data-detail data-colon :items="items" :headers="tableHeaders" />
        </div>
      </v-card>
    </div>

  </div>
</template>

<script>
import {API2} from "../../api";
import DataDetail from "../base/DataDetail.vue";
import i18n from "../../lang/i18n";
import mixin from "../../mixin";
import DashboardHeader from "../component/DashboardHeader";
import {TYPE_FORMAT_TIME} from "../../config/constant";
import { mapState } from "vuex";

export default {
  components: {DashboardHeader, DataDetail},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
    }
  },
  data() {
    return {
      detail: null
    };
  },
  mounted() {
    this.onTab(this.item);
  },
  computed: {
    ...mapState(['locale']),
    header() {
      if (this.item) {
        return this.item.name
      }
      return ''
    },
    tableHeaders() {
      return [
        {key: 'title', label: this.$t('base.title'), thStyle: {width: '50%'}},
        {key: 'data', label: this.$t('base.content')}
      ]
    },
    items() {
      const itemData = this.detail || this.item;
      if (!itemData) return [];
      let isGroup = itemData.scheduleType === 1 ? i18n.t("base.yes") : i18n.t("base.no")
      return [
        {
          title: i18n.t("schedule.employee"),
          data: itemData.name,
        },
        {
          title: i18n.t("schedule.time"),
          data: this.renderTime(itemData)
        },
        {
          title: i18n.t("schedule.date"),
          data: this.renderDate(itemData)
        },
        {
          title: i18n.t("schedule.day"),
          data: this.renderDay(itemData) ? `${i18n.t("schedule.every")} ${this.renderDay(itemData)}` : ""
        },
        {
          title: i18n.t("schedule.isGroup"),
          data: isGroup
        },
        {
          title: i18n.t("schedule.selectGroup"),
          data: itemData?.Group?.name
        },
        {
          title: i18n.t("base.createdAt"),
          data: this.formatDate(itemData.createdAt, "HH:mm DD/MM/YYYY")
        },
        {
          title: i18n.t("base.updatedAt"),
          data: this.formatDate(itemData.updatedAt, "HH:mm DD/MM/YYYY")
        },
      ]
    },
  },
  methods: {
    onTab(item) {
      if (item) this.getData(item)
    },
    async getData(item) {
      // Use the new schedule validation API to check if the specific schedule exists
      // Call API without handleError to get raw response and handle validation manually
      let res = await this.get(API2.SCHEDULE, { path: item.scheduleId }, null, false)
      
      if (res && res.data && res.data.status === 200 && res.data.data) {
        // Schedule exists, use the passed item data
        this.detail = item
      } else {
        // Schedule doesn't exist anymore, show toast and go back
        this.notifDialog({
          title: `${i18n.t("warning.warning")}!`,
          content: i18n.t("base.noData"),
          textConfirm: i18n.t('ui.confirm'),
        });
        this.onGoBack();
      }
    },
    onGoBack() {
      this.openTab(0)
    },
    renderTime(item) {
      let text = ""
      let start = item.startTime ? item.startTime.substring(0, 5) : '?'
      let end = item.endTime ? item.endTime.substring(0, 5) : '?'
      return text += `${start} - ${end}`
    },
    renderDate(schedule) {
      // Nếu cả hai đều null - hiển thị thông tin vô tận
      if (!schedule.startDate && !schedule.endDate) {
        return this.$t('schedule.indefiniteSchedule') || 'Vô tận'
      }
      
      // Nếu chỉ có một trong hai null
      let start = schedule.startDate ? this.formatDate(schedule.startDate, TYPE_FORMAT_TIME.DD_MM_YYYY) : this.$t('schedule.noStartDate') || 'Không giới hạn'
      let end = schedule.endDate ? this.formatDate(schedule.endDate, TYPE_FORMAT_TIME.DD_MM_YYYY) : this.$t('schedule.noEndDate') || 'Không giới hạn'
      
      return `${start} - ${end}`
    },
    renderDay(schedule) {
      let list = ["everyMonday", "everyTuesday", "everyWednesday", "everyThursday", "everyFriday", "everySaturday", "everySunday"]
      let dayOfWeeks = list.filter(day => schedule[day]).map(day => i18n.t(`schedule.${day}`).replace("Every ", ""))
      return dayOfWeeks.join(", ")
    },
  }
};
</script>

<style scoped>
.info {
  color: #595959;
}
</style>
